// extracted by mini-css-extract-plugin
export default {"button":"Button-module__button___cW8FM","bookmark":"Button-module__bookmark___RsOUa"};